import { NavLink } from "react-router-dom";

import "./Navbar.css";

const navItems = [
  {
    label: "Home",
    path: "/",
    end: true,
  },
  {
    label: "About",
    path: "/about",
  },
  {
    label: "Contact",
    path: "/contact",
  },
];

function Navbar() {
  return (
    <nav className="nav" aria-label="Main navigation">
      {navItems.map(({ label, path, end }) => (
        <NavLink key={path} to={path} end={end}>
          {label}
        </NavLink>
      ))}
    </nav>
  );
}

export default Navbar;
